module.exports = __webpack_public_path__ + "static/media/logo.ce74ec00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 375
// module chunks = 0